export default __webpack_public_path__ + "static/media/HotelIcon.ecbdac6b.svg";